import { AxiosResponse } from 'axios';
import { SET_CALENDAR_HOLIDAYS, SET_CALENDAR_HOLIDAY, SET_HOLIDAY, SET_HOLIDAYS, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CHECK_HOLIDAY,
  CLEAR_HOLIDAYS_ISLOADING,
  GET_CALENDAR_HOLIDAYS,
  GET_HOLIDAYS,
  REGISTER_CALENDAR_HOLIDAY,
  REMOVE_HOLIDAY,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import Holiday from '@/services/holiday';
import { Module } from 'vuex';
import { GetCalendarHolidays, GetHolidays, RegisterCalendarHoliday, RemoveHoliday } from '@/dtos/holiday.dto';

const holiday: Module<any, {}> = {
  state: {
    calendarHoliday: {
      data: null,
      isLoading: false,
    },
    calendarHolidays: {
      data: null,
      isLoading: false,
    },
    holiday: {
      data: null,
      isLoading: false,
    },
    holidays: {
      data: null,
      isLoading: false,
    }
  },
  getters: {
    calendarHoliday: (state: { calendarHoliday: any }) => state.calendarHoliday,
    calendarHolidays: (state: { calendarHolidays: any }) => state.calendarHolidays,
    holiday: (state: { holiday: any }) => state.holiday,
    holidays: (state: { holidays: any }) => state.holidays,
  },
  mutations: {
    [SET_CALENDAR_HOLIDAY]: (
      state: { calendarHoliday: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.calendarHoliday.data = payload.data) : null,
        (state.calendarHoliday.isLoading = payload.isLoading);
    },
    [SET_CALENDAR_HOLIDAYS]: (
      state: { calendarHolidays: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.calendarHolidays.data = payload.data) : null,
        (state.calendarHolidays.isLoading = payload.isLoading);
    },
    [SET_HOLIDAY]: (
      state: { holiday: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.holiday.data = payload.data) : null,
        (state.holiday.isLoading = payload.isLoading);
    },
    [SET_HOLIDAYS]: (
      state: { holidays: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.holidays.data = payload.data) : null,
        (state.holidays.isLoading = payload.isLoading);
    },
  },
  actions: {
    [GET_CALENDAR_HOLIDAYS]: async ({ commit }: any, payload: any) => {
      commit(SET_CALENDAR_HOLIDAYS, { data: null, isLoading: true });

      const result: AxiosResponse = await Holiday.getCalendarHolidays(
        payload as GetCalendarHolidays
      );

      if (result) {
        if (result.data.status) {
          commit(SET_CALENDAR_HOLIDAYS, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_CALENDAR_HOLIDAYS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_CALENDAR_HOLIDAYS, { isLoading: false });
        return false;
      }
    },
    [GET_HOLIDAYS]: async ({ commit }: any, payload: any) => {
      commit(SET_HOLIDAYS, { data: null, isLoading: true });

      const result: AxiosResponse = await Holiday.getHolidays(
        payload as GetHolidays
      );

      if (result) {
        if (result.data.status) {
          commit(SET_HOLIDAYS, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_HOLIDAYS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_HOLIDAYS, { isLoading: false });
        return false;
      }
    },
    [CHECK_HOLIDAY]: async ({ commit }: any, payload: any) => {
      commit(SET_HOLIDAY, { data: null, isLoading: true });

      const result: AxiosResponse = await Holiday.checkHoliday(
        payload as GetHolidays
      );

      if (result) {
        if (result.data.status) {
          commit(SET_HOLIDAY, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_HOLIDAY, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_HOLIDAY, { isLoading: false });
        return false;
      }
    },
    [REGISTER_CALENDAR_HOLIDAY]: async ({ commit }: any, payload: any) => {
      commit(SET_CALENDAR_HOLIDAY, { data: null, isLoading: true });

      const result: AxiosResponse = await Holiday.registerCalendarHoliday(
        payload as RegisterCalendarHoliday
      );

      if (result) {
        if (result.data.status) {
          commit(SET_CALENDAR_HOLIDAY, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_CALENDAR_HOLIDAY, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_CALENDAR_HOLIDAY, { isLoading: false });
        return false;
      }
    },
    [REMOVE_HOLIDAY]: async ({ commit }: any, payload: any) => {
      commit(SET_HOLIDAY, { data: null, isLoading: true });

      const result: AxiosResponse = await Holiday.removeHoliday(
        payload as RemoveHoliday
      );

      if (result) {
        if (result.data.status) {
          commit(SET_HOLIDAY, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_HOLIDAY, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_HOLIDAY, { isLoading: false });
        return false;
      }
    },
    [CLEAR_HOLIDAYS_ISLOADING]: ({ commit }) => {
      commit(SET_HOLIDAY, { isLoading: false });
      commit(SET_HOLIDAYS, { isLoading: false });
      commit(SET_CALENDAR_HOLIDAY, { isLoading: false });
      commit(SET_CALENDAR_HOLIDAYS, { isLoading: false });
    },
  },
};

export default holiday;
